module.exports = __webpack_public_path__ + "static/media/silicon-farm-poster-mobile.cc09f7d2.jpg";